import { ReactNode } from "react";
import {
  Box,
  Container,
  Image,
  Flex,
  SimpleGrid,
  Stack,
  Text,
  useColorModeValue,
  Link
} from "@chakra-ui/react";
import { FaInstagram, FaWhatsapp, FaEnvelope, FaPhone } from 'react-icons/fa';
import { COLORS } from "../../../colors";

const Logo = (props) => {
  return <Image src={"/logobooniuz.png"} h={10} ml={-2} />;
};

const ListHeader = ({ children }) => {
  return (
    <Text fontWeight={"500"} fontSize={"lg"} mb={2}>
      {children}
    </Text>
  );
};

export default function FooterLanding() {
  return (
    <Box
      bg={useColorModeValue("gray.50", "gray.900")}
      color={useColorModeValue("gray.700", "gray.200")}
    >
      <Container as={Stack} maxW={"6xl"} py={10}>
        <Flex
          direction={{ base: "row", md: "row" }}
          justify={{ base: "center", md: "space-between" }}
        >
          <Stack
            spacing={6}
            textAlign={{ base: "center", md: "left" }}
            flexBasis={{ base: "70%", md: "auto" }}
            flexGrow={1}
            flexShrink={0}
          >
            <Flex gap={2} align={"center"}>
              <FaInstagram />
              <Link href="https://www.instagram.com/somersetlanguagecentre" fontSize={"sm"}>somersetlanguagecentre</Link>
            </Flex>
            <Flex gap={2} align={"center"}>
              <FaWhatsapp />
              <Link fontSize={"sm"} href="https://api.whatsapp.com/send?phone=601129552">601 12 95 52</Link>
            </Flex>
            <Flex gap={2} align={"center"}>
              <FaPhone />
              <Link href="tel:+34963388933" fontSize={'sm'}>963 38 89 33</Link>
            </Flex>
            <Flex gap={2} align={"center"}>
              <FaEnvelope />
              <Link href="mailto:info@somersetlc.com" fontSize={'sm'}>info@somersetlc.com</Link>
            </Flex>
          </Stack>
          <Stack
            spacing={6}
            textAlign={{ base: "center", md: "right" }}
            flexBasis={{ base: "30%", md: "auto" }}
            flexGrow={1}
            flexShrink={0}
          >
            <Box>
              <Text fontSize={24} as={"span"} fontWeight={"bold"} color={COLORS.brand1}>Somerset <Text as={"span"} color={COLORS.brand3}>language centre </Text></Text>
            </Box>
            <Text fontSize={"sm"}>© 2024 Somerset Language Centre. All rights reserved</Text>
          </Stack>
        </Flex>
      </Container>
    </Box>
  );
}
